@if (showLoadingState) {
    <div class="process-detail-media-previews__loading">
        <tec-tile [type]="'loading'" [title]="'LOADING.MEDIA_PREVIEWS' | translate" />
    </div>
} @else if (hasVisibleMedia) {
    <div class="grid grid-e2-sm" [style.grid-template-columns]="gridTemplateColumns" [style.max-width]="gridMaxWidth">
        @if (detail.general?.video?.trim()) {
            <video class="image-process portrait" controls>
                <source [src]="detail.general?.video" type="video/mp4" />
                {{ 'GENERAL.VIDEO_NOT_SUPPORTED' | translate }}
            </video>
        }
        @if (ocrFrontPreviewUrl) {
            <tec-file-preview
                class="image-process landscape"
                [fileUrl]="ocrFrontPreviewUrl"
                (click)="onMediaClick(ocrFrontPreviewUrl)"
            />
        }
        @if (ocrBackPreviewUrl) {
            <tec-file-preview
                class="image-process landscape"
                [fileUrl]="ocrBackPreviewUrl"
                (click)="onMediaClick(ocrBackPreviewUrl)"
            />
        }
        @if (
            !ocrFrontPreviewUrl &&
            !ocrBackPreviewUrl &&
            detail.data?.OCR?.images?.temporary?.length
        ) {
            <tec-file-preview
                class="image-process landscape"
                [fileUrl]="detail.data?.OCR?.images?.temporary[0]"
                (click)="onMediaClick(detail.data?.OCR?.images?.temporary[0])"
            />
        }
        @for (selfieUrl of polSelfiePreviews; track selfieUrl) {
            <tec-file-preview
                class="image-process portrait"
                [fileUrl]="selfieUrl"
                (click)="onMediaClick(selfieUrl)"
            />
        }
        @if (detail.data?.DOCUMENTS?.images?.document?.length) {
            <tec-file-preview
                class="image-process portrait"
                [fileUrl]="detail.data?.DOCUMENTS?.images?.document[0]"
                (click)="onMediaClick(detail.data?.DOCUMENTS?.images?.document[0])"
            />
        }
        @for (img of debugFallbackImages; track img) {
            <tec-file-preview
                class="image-process portrait"
                [fileUrl]="img"
                (click)="onMediaClick(img)"
            />
        }
    </div>
}
